import './App.css';
import TemocBotWithGPT from './components/TemocBot/TemocBotWithGPT'
import TemocBotWithModel from './components/TemocBot/TemocBotWithModel';
import Home from './components/HomePage/HomePage'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <div>
        <Routes>
            <Route path="/" exact element={<Home/>} />
            <Route path="/chat" element={<TemocBotWithGPT/>} />
            <Route path="/temoctalkwithmodel" element={<TemocBotWithModel/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
